import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import ArticleCard from '../../components/cards/ArticleCard';
import Link from '../../components/Link';

const ComposableArticleCard = (props) => {
  const { slug, wide, index, type, subThemes } = props;
  const brand = useBrand();

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd={wide ? 'span 12' : 'span 6'}
      columnEndLg={wide ? 'span 6' : 'span 3'}
      columnEndXl={wide ? 'span 6' : 'span 3'}
      key={slug}
    >
      <Link
        href={`/artikelen/${slug}`}
        category="Homepage"
        label={`${type}-${index}`}
        action="click"
      >
        <ArticleCard {...props} brand={brand} subTheme={subThemes[0]} />
      </Link>
    </GridItem>
  );
};

ComposableArticleCard.defaultProps = {
  wide: false,
  subThemes: [],
};

ComposableArticleCard.propTypes = {
  slug: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  wide: PropTypes.bool,
  index: PropTypes.number.isRequired,
  subThemes: PropTypes.arrayOf(PropTypes.shape()),
};

export default ComposableArticleCard;
